import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './bootstrap.css';
import './index.css';
import App from './App';
import Home from './routes/Home/Home';
import Report from './routes/Report/Report';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />}>
                    <Route
                      element={<Home />}
                      path=""
                    />
                    <Route
                      element={<Report />}
                      path="report/:emailId"
                      loader={({ params }) => {
                          /* TODO: Get latest report id here? */
                          return params.email_id;
                      }}
                    />
                </Route>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
